(function () {
  const routes = window.megavTheme?.routes || {};
  const strings = window.megavTheme?.strings || {};
  const shopRoot = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerItems = document.querySelector('[data-cart-drawer-items]');
  const subtotal = document.querySelector('[data-cart-subtotal]');
  const counters = Array.from(document.querySelectorAll('[data-cart-count]'));

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hasCodSignal(element) {
    if (!element) return false;

    const signal = normalizeText([
      element.innerText,
      element.textContent,
      element.value,
      element.getAttribute?.('aria-label'),
      element.getAttribute?.('title'),
      element.getAttribute?.('id'),
      element.getAttribute?.('class'),
      element.getAttribute?.('href'),
      element.getAttribute?.('src')
    ].filter(Boolean).join(' '));

    return (
      signal.includes('pagar contra reembolso') ||
      signal.includes('contra reembolso') ||
      signal.includes('pago contra reembolso') ||
      signal.includes('cash on delivery') ||
      signal.includes('releasit') ||
      signal.includes('cod-form') ||
      signal.includes('cod_form') ||
      signal.includes('codbutton') ||
      signal.includes('cod-button')
    );
  }

  function isVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      rect.width > 40 &&
      rect.height > 20
    );
  }

  function getCodWrapper(element) {
    if (!element) return null;

    return (
      element.closest('[class*="releasit"]') ||
      element.closest('[id*="releasit"]') ||
      element.closest('[class*="cod"]') ||
      element.closest('[id*="cod"]') ||
      element.closest('[class*="COD"]') ||
      element.closest('[id*="COD"]') ||
      element.closest('.shopify-app-block') ||
      element.closest('[data-shopify-editor-block]') ||
      element.closest('[data-app-block]') ||
      element.closest('form') ||
      element.closest('button') ||
      element.closest('a') ||
      element.closest('[role="button"]') ||
      element.parentElement ||
      element
    );
  }

  function hideDuplicateElement(element) {
    if (!element) return;

    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('height', '0', 'important');
    element.style.setProperty('min-height', '0', 'important');
    element.style.setProperty('max-height', '0', 'important');
    element.style.setProperty('margin', '0', 'important');
    element.style.setProperty('padding', '0', 'important');
    element.style.setProperty('overflow', 'hidden', 'important');
    element.style.setProperty('opacity', '0', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('data-megav-cod-duplicate-hidden', 'true');
  }

  function dedupeCodButtons() {
    const selectors = [
      'button',
      'a',
      'input[type="button"]',
      'input[type="submit"]',
      'iframe',
      '[role="button"]',
      '[class*="releasit"]',
      '[id*="releasit"]',
      '[class*="cod"]',
      '[id*="cod"]',
      '[class*="COD"]',
      '[id*="COD"]'
    ].join(',');

    const elements = Array.from(document.querySelectorAll(selectors))
      .filter((element) => isVisible(element) && hasCodSignal(element));

    if (elements.length <= 1) return;

    const wrappers = [];

    elements.forEach((element) => {
      const wrapper = getCodWrapper(element);

      if (
        wrapper &&
        wrapper !== document.body &&
        wrapper !== document.documentElement &&
        !wrappers.includes(wrapper)
      ) {
        wrappers.push(wrapper);
      }
    });

    const cleanWrappers = wrappers.filter((wrapper, index, list) => {
      return !list.some((other, otherIndex) => {
        return otherIndex !== index && other.contains(wrapper);
      });
    });

    if (cleanWrappers.length <= 1) return;

    cleanWrappers
      .sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top)
      .forEach((wrapper, index) => {
        if (index === 0) return;
        hideDuplicateElement(wrapper);
      });
  }

  function initCodDedupeObserver() {
    dedupeCodButtons();

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(dedupeCodButtons);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'id', 'href', 'src']
    });

    window.setTimeout(dedupeCodButtons, 100);
    window.setTimeout(dedupeCodButtons, 300);
    window.setTimeout(dedupeCodButtons, 800);
    window.setTimeout(dedupeCodButtons, 1500);
    window.setTimeout(dedupeCodButtons, 3000);
    window.setTimeout(dedupeCodButtons, 5000);
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';

    return new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency',
      currency
    }).format((Number(cents) || 0) / 100);
  }

  function localePath(path) {
    const root = String(shopRoot || '/').replace(/\/$/, '/');
    return `${root}${String(path || '').replace(/^\//, '')}`;
  }

  function ajaxRoute(route, fallback) {
    const value = route || localePath(fallback);
    return value.endsWith('.js') ? value : `${value}.js`;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function openCart() {
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
  }

  function closeCart() {
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-open');
  }

  function renderCart(cart) {
    counters.forEach((counter) => {
      counter.textContent = cart.item_count;
    });

    if (subtotal) {
      subtotal.textContent = formatMoney(cart.total_price);
    }

    if (!drawerItems) return;

    if (!cart.items.length) {
      drawerItems.innerHTML = `
        <div class="empty-state">
          <p class="eyebrow">Carrito vacío</p>
          <h3>Tu próxima máquina empieza aquí.</h3>
          <a class="button button--primary" href="${routes.cart || '/cart'}">Ver carrito</a>
        </div>
      `;
      return;
    }

    drawerItems.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img class="cart-line__img" src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
        : '<div class="cart-line__img placeholder-media" aria-hidden="true"></div>';

      return `
        <div class="cart-line" data-line-key="${escapeHtml(item.key)}">
          <a class="cart-line__image" href="${item.url}">${image}</a>
          <div class="cart-line__info">
            <a href="${item.url}">${escapeHtml(item.product_title)}</a>
            ${item.variant_title ? `<small>${escapeHtml(item.variant_title)}</small>` : ''}
            <span>${formatMoney(item.final_line_price)}</span>
            <div class="cart-line__controls">
              <button type="button" data-cart-quantity data-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Restar cantidad">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-quantity data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Sumar cantidad">+</button>
              <button type="button" data-cart-remove data-key="${escapeHtml(item.key)}">Eliminar</button>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function getCart() {
    return fetch(localePath('cart.js'), {
      headers: { Accept: 'application/json' }
    }).then((response) => response.json());
  }

  function refreshCart(shouldOpen = true) {
    return getCart().then((cart) => {
      renderCart(cart);

      if (shouldOpen) openCart();

      document.dispatchEvent(new CustomEvent('megav:cart:updated', { detail: { cart } }));

      return cart;
    });
  }

  function addForm(form) {
    return fetch(ajaxRoute(routes.cartAdd, 'cart/add.js'), {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    }).then((response) => {
      if (!response.ok) throw new Error(strings.cartError || 'Cart error');
      return refreshCart(true);
    });
  }

  function addItems(items) {
    return fetch(ajaxRoute(routes.cartAdd, 'cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    }).then((response) => {
      if (!response.ok) throw new Error(strings.cartError || 'Cart error');
      return refreshCart(true);
    });
  }

  function changeLine(key, quantity) {
    return fetch(ajaxRoute(routes.cartChange, 'cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    }).then((response) => {
      if (!response.ok) throw new Error(strings.cartError || 'Cart error');
      return response.json();
    }).then((cart) => {
      renderCart(cart);
      return cart;
    });
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cart-open]');

    if (openButton) {
      event.preventDefault();
      refreshCart(true);
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }

    const quantityButton = event.target.closest('[data-cart-quantity]');

    if (quantityButton) {
      event.preventDefault();
      changeLine(quantityButton.dataset.key, Number(quantityButton.dataset.quantity || 0));
      return;
    }

    const removeButton = event.target.closest('[data-cart-remove]');

    if (removeButton) {
      event.preventDefault();
      changeLine(removeButton.dataset.key, 0);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');

    if (!form) return;

    const submitter = event.submitter || document.activeElement;

    if (submitter && hasCodSignal(submitter)) {
      return;
    }

    if (submitter && !submitter.matches('[data-add-to-cart]')) {
      return;
    }

    event.preventDefault();

    const button = form.querySelector('[data-add-to-cart]');
    const original = button?.textContent;

    if (button) {
      button.disabled = true;
      button.textContent = 'Agregando...';
    }

    addForm(form)
      .then(() => {
        if (button) button.textContent = strings.added || 'Agregado';
      })
      .catch(() => {
        if (button) button.textContent = strings.cartError || 'Error';
      })
      .finally(() => {
        window.setTimeout(() => {
          if (button) {
            button.disabled = false;
            button.textContent = original || strings.addToCart || 'Agregar';
          }
        }, 900);
      });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCodDedupeObserver);
  } else {
    initCodDedupeObserver();
  }

  window.MegavCart = {
    open: openCart,
    close: closeCart,
    refresh: refreshCart,
    addItems
  };
})();